import { CSSProperties, MouseEvent, PropsWithChildren, useMemo } from 'react';

import Loader from '@components/loader/loader';

import styles from './basic-button.module.scss';

interface Props extends PropsWithChildren {
    text?: string;
    width?: number | string;
    style?: CSSProperties;
    loading?: boolean;
    disabled?: boolean;
    onClick?: () => void;
    shortcut?: string;
    disabledReason?: string;
}

const BasicButton = (props: Props) => {
    const onClick = (ev: MouseEvent) => {
        if (props.loading) return;
        ev.preventDefault();
        props.onClick?.();
    };

    const renderLoading = useMemo(() => <Loader size={16} />, [props.loading]);

    const renderContent = useMemo(
        () => (
            <>
                {props.children}
                {props.shortcut && (
                    <span className={styles.shortcut}>{props.shortcut}</span>
                )}
                {props.disabled && props.disabledReason && (
                    <span className={styles.disabledTooltip}>
                        {props.disabledReason}
                    </span>
                )}
            </>
        ),
        [props.children, props.shortcut, props.disabled, props.disabledReason]
    );

    return (
        <button
            className={styles.basicButton}
            style={{ ...props.style, width: props.width ?? 'fit-content' }}
            disabled={props.disabled ?? false}
            onClick={onClick}
        >
            {props.loading ? renderLoading : renderContent}
        </button>
    );
};

export default BasicButton;
